import React from "react";
import { BasemapVariant } from "../../config/mapProviders";

/** Overlaid pill control for switching basemap look. Hidden when there's only one. */
const BasemapSwitcher: React.FC<{
  variants: BasemapVariant[];
  activeId: string;
  onChange: (id: string) => void;
  disabled?: boolean;
}> = ({ variants, activeId, onChange, disabled }) => {
  if (variants.length < 2) return null;
  return (
    <div className="absolute right-2 top-2 z-[400] flex overflow-hidden rounded-md border border-black/40 bg-ink-950/85 backdrop-blur-sm">
      {variants.map((v) => (
        <button
          key={v.id}
          type="button"
          disabled={disabled}
          onClick={() => onChange(v.id)}
          aria-pressed={v.id === activeId}
          className={`px-2.5 py-1 text-meta font-medium transition-colors focus:outline-none focus-visible:ring-1 focus-visible:ring-crane-400 disabled:opacity-50 ${
            v.id === activeId ? "bg-crane-500 text-ink-950" : "text-ink-300 hover:text-ink-100"
          }`}
        >
          {v.label}
        </button>
      ))}
    </div>
  );
};

export default BasemapSwitcher;
